"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.searchDynamicSegments = void 0;
const searchDynamicSegments = (client) => async ({ partnerId, customerCode, requests }) => {
    const response = await client.post(`/v1/bff/appro/partners/${partnerId}/customers/${customerCode}/segments`, requests);
    return response.data;
};
exports.searchDynamicSegments = searchDynamicSegments;
